import {
    GET_ALLOTVEHICLE,
    GET_AVAILABLESUPPLIERS,
    GET_AVAILABLEVEHICLE,
  } from 'resources/actionTypes';
  
  export function allotVehicle(payloadData, page, payload) {
    const data = {
      trip: payloadData,
      page: page,
      payload: payload,
    };
  
    return {
      type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED,
      payload: data,
    };
  }
  
  export function getAvailableVehicle(payload) {
    return {
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_REQUESTED,
      payload: payload,
    };
  }
  
  export function clearGetAvailableVehicle() {
    return {
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_CLEAR,
    };
  }
  
  export function getAvailableSuplliers(payload) {
    return {
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_REQUESTED,
      payload: payload,
    };
  }
  
  export function clearGetAvailableSuplliers() {
    return {
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_CLEAR,
    };
  }
  
  